// extracted by mini-css-extract-plugin
export default {"btnCommonTouchable":"style__btnCommonTouchable___pXFwl","btnActiveTouchable":"style__btnActiveTouchable___rifMe"};